import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Importa CommonModule
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.css'
})
export class SupportComponent {

}
